import { Button, Col, Form, Input, message, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { NumberOfUnitInput } from "./components/NumberOfUnitInput";
import { DynamicPhone } from "../../../components/DynamicPhone";
import { Link, useNavigate } from "react-router-dom";
import { auth, db, registerWithEmailAndPassword } from "../../../firebase";
import { PropagateLoader } from "react-spinners";
import axios from "axios";
import { toast } from "react-hot-toast";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";

const Register = () => {
  const [user, loading] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
    if (user) {
      navigate("/");
      setIsLoading(false);
    }

    console.log("***********");
  }, [user, loading]);

  const onFinish = async (values) => {
    setIsSubmitted(true);
    const usersRef = collection(db, "allCompanies");

    try {
      const querySnapshot = await getDocs(
        query(usersRef, where("companyName", "==", values.companyName))
      );
      if (querySnapshot.size > 0) {
        toast.error(`${values.companyName} company is already registered!`);
        setErrorMessage(true);
      } else {
        const userData = {
          email: values.email,
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: values.phoneNumber,
          totalUnits: values.totalUnits,
          role: "admin",
          companyName: values.companyName,
        };
        try {
          const response = await axios.post(
            "https://us-central1-sayeagle-77c75.cloudfunctions.net/api/users",
            userData
          );
          console.log(response.data); // User created successfully
          toast.success(
            "User created successfully. Please check your email and verify your account."
          );


          navigate("/login");
        } catch (error) {
          console.error("Error creating user:", error);
          toast.error(
            "There was an issue creating your account. Please try again later."
          );
          setIsSubmitted(false);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An unexpected error occurred. Please try again later.");
      setIsSubmitted(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.error(
      "All fields are required. Please fill in all the required information."
    );
    setIsSubmitted(false);
  };

  const checkUnit = (_, value) => {
    if (value.number > 0) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Unit must be greater than zero!"));
  };

  return (
    <div>
      {isLoading ? (
        <PropagateLoader color="#006eb7" size={5} className="loadingSpinner" />
      ) : (
        <Row>
          <Col xs={24} md={10} lg={10}>
            <div className="leftSide">
              <h1 className="companyTitle">SayEagle</h1>
              <h3 className="userLoginType">Property Manager</h3>
            </div>
          </Col>
          <Col xs={24} md={14} lg={14}>
            <div className="rightSide">
              <h3 className="titlePage">Register</h3>

              <Form
                name="basic"
                initialValues={{
                  remember: true,
                  totalUnits: {
                    number: 0,
                  },
                }}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{
                  maxWidth: 500,
                  width: "100%",
                }}
              >
                <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your First Name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Last Name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Email Address"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email Address!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Phone Number"
                  name="phoneNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Phone Number!",
                    },
                  ]}
                >
                  <DynamicPhone />
                </Form.Item>

                <Form.Item
                  label="Company Name"
                  name="companyName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Company Name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Total Units Managed in Portfolio: "
                  name="totalUnits"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Total Units!",
                      validator: checkUnit,
                    },
                  ]}
                >
                  <NumberOfUnitInput />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={isSubmitted}
                  >
                    {isSubmitted ? "please wait..." : "Register"}
                  </Button>
                </Form.Item>
              </Form>
              <span>
                Already have an account? <Link to="/login">Login</Link> now.
              </span>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Register;
